import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=0c36e842"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports